import React from 'react';
import { Text } from '@televet/kibble-ui/build/components/Text';
import { Flex, SpaceProps } from '@televet/kibble-ui/build/chakra';
import { InfoIcon } from 'shared/components/InfoIcon';

interface FieldTitleProps extends SpaceProps {
  fieldTitleText: string;
  isRequired?: boolean;
  popoverText?: string;
}

const FieldTitle = ({ fieldTitleText, isRequired = true, popoverText, ...rest }: FieldTitleProps): JSX.Element => {
  return (
    <Flex mx={5} mt={3} {...rest}>
      <Flex alignItems="center" justifyContent="flex-start" gap={1}>
        <Text>{fieldTitleText}</Text>
        {isRequired && <Text variant="danger">*</Text>}
      </Flex>
      {popoverText && <InfoIcon text={popoverText} />}
    </Flex>
  );
};

export default FieldTitle;
